import { AnyObject, BaseQuery, UseQueryCount } from '@hb/shared'
import { useEffect, useState } from 'react'
import { getQueryCount } from '../../backend/functions/other'

export type GetQueryCount<T extends AnyObject> = (query: BaseQuery<T>) => Promise<number>

export const useQueryCount = <T extends AnyObject>(query: BaseQuery<T> | null): UseQueryCount => {
  const [count, setCount] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!query) {
      setLoading(false)
      setError(null)
      setCount(null)
      return
    }
    setLoading(true)
    getQueryCount(query)
      .then(d => {
        setCount(d)
      })
      .catch(err => {
        console.error('error getting query count', err)
        setError(err.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [query])

  return {
    count,
    loading,
    error,
  }
}
